import React, { useReducer, useEffect } from "react";
import NoFooterLayout from "../components/core/NoFooterLayout";
import { Grid, Container } from "@mui/material";
import CryptoNewsPage from "../components/crypto-news/CryptoNewsPage";
import api from "src/store/features/api";

export default function CryptoNews() {
  const { data: cryptoNewsDashboard } = api.useGetDashboardCryptoNewsQuery();
  const [useDefaultTheme, toggle] = useReducer((theme: any) => !theme, true);

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, []);

  return (
    <NoFooterLayout
      toggleTheme={toggle}
      useDefaultTheme={useDefaultTheme}
      back
      title={"Crypto News"}
      hideRightIcon
    >
      <Container>
        <Grid container justifyContent="center">
          {cryptoNewsDashboard &&
            cryptoNewsDashboard.length > 0 &&
            cryptoNewsDashboard.map((news: any, index: number) => (
              <Grid item key={index}>
                <CryptoNewsPage
                  source={`${news.source}`}
                  time={`${news.timestamp}`}
                  title={news.title}
                  imageURL={news.image}
                  urlReference={news.link}
                />
              </Grid>
            ))}
        </Grid>
      </Container>
    </NoFooterLayout>
  );
}
